import {Component, OnInit} from '@angular/core';
import {FormBaseComponent} from '@utils-lib';
import {InternethandelInfluencer} from '@nachdigal';
import {FormBuilder} from '@angular/forms';
import {DatevMessageService} from '@datev/ngx-ui-components';
import {TranslateService} from '@ngx-translate/core';

@Component({
    selector: 'common-ui-influencer',
    templateUrl: './influencer.component.html',
    styleUrls: ['./influencer.component.scss']
})
export class InfluencerComponent extends FormBaseComponent<InternethandelInfluencer> implements OnInit {

    constructor(private readonly formBuilder: FormBuilder,
                protected readonly messageService: DatevMessageService,
                protected readonly translateService: TranslateService) {
        super(messageService);
    }

    public clearPlattformen($event: unknown): void {
        if (!$event) {
            this.data.plattformen = [];
        }
    }

    public ngOnInit(): void {
        if (!this.data.umsaetzeUeberPlattform) {
            this.data.umsaetzeUeberPlattform = false;
        }
        if (!this.data.plattformen) {
            this.data.plattformen = [];
        }
        super.ngOnInit();
    }

    public addPlattform(): void {
        this.data.plattformen.push({});
    }

    public removePlattform(index: number): void {
        this.data.plattformen.splice(index, 1);
    }

    protected createForm(): void {
        this.form = this.formBuilder.group({
            umsaetzeUeberPlattform: [this.data.umsaetzeUeberPlattform]
        });
    }
}

